import { parseDate } from './dateUtils';

export enum DeviceType {
  RevA = 'Rev A',
  RevB = 'Rev B',
  SmokeOnly = 'Smoke Only',
  SmokeCOBLE = 'Smoke CO BLE',
  SmokeCOTI = 'Smoke CO TI',
  SmokeCOIAQ = 'Smoke CO IAQ',
  SmokeIAQOnly = 'Smoke IAQ Only',
  COIAQApollo = 'CO-IAQ (Apollo Device)',
  SmartFx = 'Smart Fx',
  AthenaCO = 'Athena Co',
  AthenaCOIAQ = 'Athena Co IAQ',
  OrchidSmoke = 'Orchid Smoke',
  OrchidSmokeCo = 'Orchid Smoke Co',
  Unknown = ''
}

export function fixDevice(d: any): void {
    if (d.charge_start) {
        d.charge_start = parseDate(d.charge_start);
    }
    d.seen = d.fwrev !== '0000000';
    if (!d.seen) {
        d.fwrev = '';
    }
    if (d.model === 'camera') {
        if (d.builds.length > 0) {
            d.can_upgrade = d.fwrev !== d.builds[0].fw;
        }
    }
}

export function getDeviceType(device: any): DeviceType {
  const capSensor: string[] = device["cap_sensor"] ?? [];
  const sensors = capSensor.map(s => s.toLowerCase());
  const model = device["model"].toLowerCase();
  const serialnumber = device["serialnumber"];

  const hasSmoke = sensors.includes("smoke");
  const hasCO = sensors.includes("co");
  const hasIAQ = sensors.includes("iaq");

  switch (model) {
    case 'smartfx': return DeviceType.SmartFx;
    case 'waterleakdetector':
      if (serialnumber.substring(0, 4) === "1811") return DeviceType.RevA;
      if (serialnumber.substring(0, 4) === "1812") return DeviceType.RevB;
      break;
    case 'wifidetector':
      if (hasSmoke && hasCO && serialnumber.startsWith("0812")) return DeviceType.SmokeCOBLE;
      if (hasSmoke && hasCO) return DeviceType.SmokeCOTI;
      if (hasSmoke) return DeviceType.SmokeOnly;
      break;
    case 'cowifidetector': return DeviceType.COIAQApollo;
    case 'esswfac':
      if (hasSmoke && hasCO) return DeviceType.OrchidSmokeCo;
      if (hasSmoke && sensors.length === 1) return DeviceType.OrchidSmoke;
      break;
    case 'copd-wf/aq':
      if (hasCO && hasIAQ) return DeviceType.AthenaCOIAQ;
      if (hasCO) return DeviceType.AthenaCO;
      break;
    case 'wifiiaqdetector':
      if (hasSmoke && hasCO && hasIAQ) return DeviceType.SmokeCOIAQ;
      if (hasSmoke && hasIAQ) return DeviceType.SmokeIAQOnly;
      break;
    default:
      return DeviceType.Unknown;
  }
  return DeviceType.Unknown;
}
